<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Nome" v-model="current.nasname" outlined dense></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Senha" v-model="current.secret" outlined dense></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Apelido" v-model="current.shortname" outlined dense></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-select label="Tipo" v-model="current.type" :items="type" outlined dense></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-text-field label="Descrição" v-model="current.description" outlined dense></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    type: [
      { text: "Cisco", value: "cisco" },
      { text: "Outros", value: "other" }
    ]
  }),
  created: function() {
    this.load();
  },
  methods: {
    load: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/nas" + "/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token }
        })
        .then(function(response) {
          me.current = response.data;
        })
        .catch(function() {
          console.log("nas fail");
        });
    },
    save: function() {
      var token = localStorage.getItem("token");
      if (this.current.id == 0) {
        api
          .post("/nas", this.current, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(function() {
            alert("NAS cadastrado com sucesso!");
            router.push({ path: "/nas" });
          });
      } else {
        api
          .put("/nas/" + this.current.id, this.current, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(function() {
            alert("NAS atualizado com sucesso!");
            router.push({ path: "/nas" });
          });
      }
    }
  }
};
</script>